import React, { ReactNode, useState } from 'react';
import { ConfirmationContextType } from './types';
import { ConfirmationContext } from './ConfirmationContext';
import ConfirmationModal from '../../components/modals/confirmation/ConfirmationModal';
import { t } from '../i18n';

interface Props {
  children: ReactNode;
}

interface State {
  text?: string;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmationProvider(props: Props) {
  const defaultText = t('common.commonTexts.toConfirmPressOk');

  const [state, setState] = useState<State>({
    text: defaultText,
    isOpen: false,
    onConfirm: () => {},
    onCancel: () => {},
  });

  function confirm(txt?: string) {
    const text = txt || defaultText;
    return new Promise((resolve, reject) => {
      setState({
        text: text,
        isOpen: !state.isOpen,
        onConfirm() {
          setState({ ...state, isOpen: false, text: text });
          resolve(true);
        },
        onCancel() {
          setState({ ...state, isOpen: false, text: text });
          reject(false);
        },
      });
    });
  }

  const context: ConfirmationContextType = {
    isOpen: state.isOpen,
    confirm: confirm,
  };

  return (
    <ConfirmationContext.Provider value={context}>
      <ConfirmationModal confirmationData={state} />
      {props.children}
    </ConfirmationContext.Provider>
  );
}
